import React from 'react';
import "./About.css";
import Navbar from '../../Components/Navbar/Navbar';
import img from "./about-image.jpg";
import Footer from '../../Components/Footer/Footer';


function About() {
    return (
        <div>
        <div className="about">
        <Navbar/>
            <div className="about-heading">
                <div className="header">
              <div className="heading">ABOUT US</div>
            </div>
            </div>
            <div className="about__body">
                <img src={img} height="450px" width="550px" alt="GDSC-GTBIT" />
                <div className="about__paragraph">
                    <p className="about-para"> <b>Google Developer Student Clubs GTBIT</b> is a community group for students interested in Google developer technologies. Students from all domains with an interest in growing as a developer are welcome. By joining GDSC GTBIT, students will grow knowledge in a peer-to-peer learning environment and build solutions for the practical problems faced by community around you.
                    With us, you will learn latest technologies, event management skills, team spirit and leadership qualities. </p>
                </div>
            </div>
            </div>
            <Footer/>
        </div>
    )
}

export default About;
